import { actionTypes } from '../actions/menu'

const initial = {
	open: false
}

export default (state = initial, action) => {
  switch (action.type) {
  	case actionTypes.SET_DROPDOWN:
      return Object.assign({}, state, {
        open: !state.open
    })

  	default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/menu.js